import { createSlice } from '@reduxjs/toolkit'

export type OnboardingStage =
  | 'WORKFORCE_SYNC'
  | 'STRIPE_SYNC'
  | 'ASYNC_ITEMS'
  | 'SUCCESS'
  | null
export type SectionStatus =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'BLOCKED'
  | 'NOT_STARTED'
  | 'ATTENTION_NEEDED'
export type SectionType =
  | 'EMPLOYEE_SYNC'
  | 'WORKSITE_SYNC'
  | 'FUNDING_SOURCE_VERIFICATION'
  | 'KYC_VERIFICATION'
  | 'PAYROLL_DATES'
  | 'COMMUTER_BENEFIT_SETUP'
  | 'PROGRAM_LAUNCH'
  | 'EMPLOYEE_INVITE'
  | 'ADDITIONAL_DETAILS'
export type WorkforceSyncType = 'HRIS' | 'CSV' | null

export interface OnboardingSection {
  sectionType: SectionType | null
  completedOn: string | null
  status: SectionStatus | null
}

export interface OnboardingState {
  onboardingFetchingStatus: 'fetching' | 'success' | 'error' | null
  id: string | null
  completedOn: string | null
  stage: OnboardingStage
  workforceSyncType: WorkforceSyncType
  sections: OnboardingSection[]
  welcomeModalShown: boolean
  hasInvitedCommuters: boolean
  isEmployeeOnboarding: boolean
  justCompletedOnboarding: boolean
}

const INITIAL_STATE: OnboardingState = {
  onboardingFetchingStatus: null,
  id: null,
  completedOn: null,
  stage: 'SUCCESS',
  workforceSyncType: null,
  sections: [],
  welcomeModalShown: false,
  hasInvitedCommuters: false,
  isEmployeeOnboarding: false,
  justCompletedOnboarding: false,
}

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: INITIAL_STATE,
  reducers: {
    setOnboardingFetchingStatus: (state, action) => {
      state.onboardingFetchingStatus = action.payload
    },
    setOnboarding: (state, action) => {
      state.id = action.payload.id
      state.completedOn = action.payload.completedOn
      state.stage = action.payload.stage
      state.sections = action.payload.sections
      state.workforceSyncType = action.payload.workforceSyncType
      state.hasInvitedCommuters = Boolean(action.payload.hasInvitedCommuters)
    },
    setOnboardingStage: (state, action) => {
      state.stage = action.payload
    },
    setWorkforceSyncType: (state, action) => {
      state.workforceSyncType = action.payload
    },
    setOnboardingSectionStatus: (state, action) => {
      const sectionType = action.payload.sectionType
      const newSections = state.sections.map((section) => {
        if (section.sectionType === sectionType) {
          section.status = action.payload.status
        }
        return section
      })
      state.sections = newSections
    },
    setWelcomeModalShown: (state, action) => {
      state.welcomeModalShown = action.payload
    },
    setIsEmployeeOnboarding: (state, action) => {
      state.isEmployeeOnboarding = action.payload
    },
    setAllOnboardingSections: (state, action) => {
      state.sections = action.payload
    },
    setJustCompletedOnboarding: (state, action) => {
      state.justCompletedOnboarding = action.payload
    },
  },
})

export const onboardingReducer = onboardingSlice.reducer
export const onboardingReducers = {
  ...onboardingSlice.actions,
}
